/**
 * @description
 *	List of HTTP headers.
 */
enum HTTPHeader {
	// Standard.
	Accept = "Accept",
	Authorization = "Authorization",
	ContentEncoding = "Content-Encoding",
	ContentLength = "Content-Length",
	ContentRange = "Content-Range",
	ContentType = "Content-Type",
	UserAgent = "User-Agent",

	// Custom.
	XSaniiAPIKey = "X-Sanii-API-Key",
	XSaniiClientId = "X-Sanii-Client-Id",
	XSaniiClientSecret = "X-Sanii-Client-Secret",
	XSaniiIntegrationId = "X-Sanii-Integration-Id",
	XSaniiIntegrationSecret = "X-Sanii-Integration-Secret",
	XSaniiNextToken = "X-Sanii-Next-Token"
}

export default HTTPHeader
